import { createFileRoute } from '@tanstack/react-router';
import type { ReactElement } from 'react';

import { PhonePage } from '~/features/setup-studio/phone/phone-page';

/**
 * The phone hand-off's page (step 5.15 of docs/plans/onboarding-harness/phase-05.md):
 * opened from the code on a phone, with no sign-in. Outside `_app` and
 * `_public` and with no `Require`: the link's token is the only key.
 */
function PhoneRoute(): ReactElement {
  const { token } = Route.useParams();
  return <PhonePage token={token} />;
}

export const Route = createFileRoute('/p/$token')({ component: PhoneRoute });
